
const apiConfig = {
    GENERATE_LOGIN_OTP: {
        url: '/auth/ops/verify',
        method: 'POST'
    },
    LOGIN: {
        url: '/auth/ops/login',
        method: 'POST'
    },
    FETCH_USER_PROFILE: {
        url: '/user/profile',
        method: 'GET'
    },
    UPDATE_USER_PROFILE: {
        url: 'h/<hubId>/profile',
        method: 'GET'
    },
    FETCH_USERS: {
        url: '/h/<hubId>/user',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_USER: {
        url: '/h/<hubId>/user/<userId>/edit',
        method: 'GET',
        staleTime: 0
    },
    CREATE_USER: {
        url: '/h/<hubId>/user',
        method: 'POST',
    },
    UPDATE_USER: {
        url: '/h/<hubId>/user/<userId>',
        method: 'PUT',
    },
    DELETE_USER: {
        url: '/h/<hubId>/user/<userId>',
        method: 'DELETE',
    },
    FETCH_USER_BRANDS: {
        url: '/h/<hubId>/brand/list',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_ROLES: {
        url: '/h/role',
        method: 'GET',
        staleTime: 10*60*1000
    },

    CREATE_CAMPAIGN: {
        url: '/ops/campaign',
        method: 'POST'
    },

    FETCH_CAMPAIGNS: {
        url: '/ops/campaign',
        method: 'GET',
        staleTime: 1*60*1000
    },

    FETCH_CAMPAIGNS_COUNT: {
        url: '/ops/campaign/totals',
        method: 'GET',
        staleTime: 1*60*1000
    },

    FETCH_CAMPAIGN: {
        url: '/ops/campaign/<campaignId>',
        method: 'GET',
        staleTime: 0
    },

    FETCH_CAMPAIGN_DETAILS: {
        url: '/ops/campaign/<campaignId>/edit',
        method: 'GET',
        staleTime: 0
    },
    UPDATE_CAMPAIGN_DETAILS: {
        url: '/ops/campaign/<campaignId>',
        method: 'PUT',
    },
    FETCH_CAMPAIGN_REQUIREMENT: {
        url: '/ops/campaign/<campaignId>/requirement',
        method: 'GET',
        staleTime: 0
    },

    FETCH_CITIES: {
        url: '/ops/city/list',
        method: 'GET'
    },
    FETCH_TOPICS: {
        url: '/ops/topic/list',
        method: 'GET'
    },
    FETCH_AGENCIES: {
        url: '/ops/agency/list',
        method: 'GET'
    },
    FETCH_HUBS: {
        url: '/ops/hub/list',
        method: 'GET'
    },
    SEARCH_CAMPAIGNS: {
        url: '/ops/campaign/list',
        method: 'GET'
    },
    FETCH_REGIONS: {
        url: '/ops/region/list',
        method: 'GET',
        staleTime: 10*60*1000
    },
    FETCH_LANGUAGES: {
        url: '/ops/language/list',
        method: 'GET'
    },

    FETCH_CAMPAIGN_CREATIVES: {
        url: '/ops/campaign/<campaignId>/creative',
        method: "GET",
        staleTime: 0
    },
    UPDATE_CAMPAIGN_CREATIVES: {
        url: '/ops/campaign/<campaignId>/creative',
        method: "POST"
    },
    FETCH_CAMPAIGN_GALLERY: {
        url: '/ops/campaign/<campaignId>/file',
        method: "GET",
        staleTime: 0
    },
    ADD_CAMPAIGN_GALLERY_IMAGE: {
        url: '/ops/campaign/<campaignId>/file',
        method: "POST",
    },
    DELETE_CAMPAIGN_GALLERY_IMAGE: {
        url: '/ops/campaign/<campaignId>/file/<fileId>',
        method: "DELETE",
    },
    FETCH_CAMPAIGN_MILESTONES: {
        method: 'GET',
        url: '/ops/campaign/<campaignId>/milestone',
        staleTime: 5*60*1000
    },
    UPDATE_CAMPAIGN_MILESTONES: {
        method: 'POST',
        url: '/ops/campaign/<campaignId>/milestone',
    },
    UPDATE_CAMPAIGN_MILESTONE: {
        method: 'PUT',
        url: '/ops/campaign/<campaignId>/milestone/<milestoneId>',
    },
    CREATE_CAMPAIGN_MILESTONE: {
        method: 'POST',
        url: '/ops/campaign/<campaignId>/milestone',
    },
    FETCH_CAMPAIGN_GIGS: {
        method: 'GET',
        url: '/ops/campaign/<campaignId>/gig',
        staleTime: 5*60*1000
    },
    UPDATE_CAMPAIGN_GIG: {
        method: 'PUT',
        url: '/ops/campaign/<campaignId>/gig/<gigId>',
    },
    CREATE_CAMPAIGN_GIG: {
        method: 'POST',
        url: '/ops/campaign/<campaignId>/gig',
    },
    UPDATE_MILESTONE_GIGS: {
        method: 'POST',
        url: '/ops/campaign/<campaignId>/milestone/<milestoneId>/gigs'
    },
    UPDATE_MILESTONE_CTAS: {
        method: 'POST',
        url: '/ops/campaign/<campaignId>/milestone/<milestoneId>/cta'
    },
    FETCH_CAMPAIGN_CREATE_DATA: {
        url: '/ops/campaign/create',
        method: 'GET',
        staleTime: 5*60*1000
    },
    FETCH_CAMPAIGN_SCREENING_QUESTIONS: {
        url: '/ops/campaign/<campaignId>/screening-question',
        method: 'GET',
        staleTime: 5*60*1000
    },
    CREATE_CAMPAIGN_SCREENING_QUESTION: {
        url: '/ops/campaign/<campaignId>/screening-question',
        method: 'POST',
    },
    UPDATE_CAMPAIGN_SCREENING_QUESTION: {
        url: '/ops/campaign/<campaignId>/screening-question/<questionId>',
        method: 'PUT',
    },
    DELETE_CAMPAIGN_SCREENING_QUESTION: {
        url: '/ops/campaign/<campaignId>/screening-question/<questionId>',
        method: 'DELETE',
    },
    REQUEST_CAMPAIGN_APPROVAL: {
        url: '/ops/campaign/<campaignId>/approval',
        method: 'POST',
    },
    MARK_CAMPAIGN_COMPLETED: {
        url: '/ops/campaign/<campaignId>/complete',
        method: 'POST',
    },

    FETCH_CAMPAIGN_APPLICATIONS: {
        url: '/ops/campaign/<campaignId>/application',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_CAMPAIGN_COLLABORATIONS: {
        url: '/ops/campaign/<campaignId>/collaboration',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_APPLICATION: {
        url: '/ops/campaign/<campaignId>/application/<applicationId>',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_APPLICATION_POSTS: {
        url: '/ops/campaign/<campaignId>/application/<influencerId>/post',
        method: 'GET',
        staleTime: 1*60*1000
    },
    PROCESS_APPLICATION: {
        url: '/ops/campaign/<campaignId>/application/<applicationId>',
        method: 'PUT',
    },
    BOOKMARK_APPLICATION: {
        url: '/ops/campaign/<campaignId>/application/<applicationId>/bookmark',
        method: 'POST',
    },
    FETCH_APPLICATION_COST: {
        url: '/ops/campaign/<campaignId>/application/<applicationId>/cost',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_SHORTLISTED_SUMMARY: {
        url: '/ops/campaign/<campaignId>/shortlist/summary',
        method: 'GET',
        staleTime: 0
    },
    APPROVE_SHORTLISTED_APPLICATION: {
        url: '/ops/campaign/<campaignId>/shortlist/approve',
        method: 'POST',
    },
    REJECT_ALL_APPLICATIONS: {
        url: '/ops/campaign/<campaignId>/application/reject',
        method: 'POST',
    },
    REVERT_APPLICATION_REJECTION: {
        url: '/ops/campaign/<campaignId>/application/<applicationId>/reset',
        method: 'POST',
    },
    UPDATE_APPLICATION_QUOTED_OFFER: {
        url: '/ops/campaign/<campaignId>/application/<applicationId>/quoted-offer',
        method: 'POST',
    },
    FETCH_SOCIAL_ACCOUNT: {
        url: '/ops/social-account/<socialAccountId>',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_SOCIAL_ACCOUNT_APPLICATIONS: {
        url: '/ops/social-account/<socialAccountId>/application',
        method: 'GET',
        staleTime: 10*60*1000
    },
    FETCH_SOCIAL_ACCOUNT_COLLABORATIONS: {
        url: '/ops/social-account/<socialAccountId>/collaboration',
        method: 'GET',
        staleTime: 10*60*1000
    },
    FETCH_CAMPAIGN_PAYMENTS: {
        url: '/ops/campaign/<campaignId>/payment',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_CAMPAIGN_INSIGHTS: {
        url: '/ops/campaign/<campaignId>/insights',
        method: 'GET',
        staleTime: 5*60*1000
    },
    FETCH_CAMPAIGN_PERFORMANCE: {
        url: '/ops/campaign/<campaignId>/performance',
        method: 'GET',
        staleTime: 5*60*1000
    },
    FETCH_CAMPAIGN_CONTENT: {
        url: '/ops/campaign/<campaignId>/post',
        method: 'GET',
        staleTime: 10*60*1000
    },
    FETCH_COLLABORATION_TASKS: {
        url: '/ops/collaboration/task',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_CAMPAIGNS_ACTIVITY: {
        url: '/ops/campaign/activity',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_COLLABORATION_MILESTONE: {
        url: '/ops/campaign/<campaignId>/collaboration/<collaborationId>/milestone/<milestoneId>',
        method: "GET",
        staleTime: 1*60*1000
    },
     FETCH_COLLABORATION_PERMALINK_FILE: {
        method: "POST",
        url: "/ops/campaign/<campaignId>/collaboration/<collaborationId>/permalink-file",
        staleTime: 10*60*1000
    },
    PROCESS_COLLABORATION_MILESTONE_STEP: {
        method: 'POST',
        url: "/ops/campaign/<campaignId>/collaboration/<collaborationId>/step"
    },
    SUBMIT_STEP_DEADLINE: {
        method: "POST",
        url: "/ops/campaign/<campaignId>/collaboration/<collaborationId>/step/<stepSlug>/deadline"
    },
     FETCH_ADDRESS: {
        url: '/ops/address/<addressUUID>',
        method: "GET",
        staleTime: 10*60*1000
    },
     GET_SIGNED_GCS_URL: {
        url: '/ops/campaign/<campaignId>/collaboration/<collaborationId>/upload/url',
        method: "POST"
    },
    LINK_UPLOADED_GCS_FILE_WITH_MILESTONE_STEP: {
        url: '/ops/campaign/<campaignId>/collaboration/<collaborationId>/upload/link',
        method: 'POST'
    },
    FETCH_COLLABORATIONS:  {
        url: '/ops/collaboration',
        method: 'GET',
        staleTime: 5*60*1000
    },
    FETCH_COLLABORATION: {
        url: '/ops/campaign/<campaignId>/collaboration/<collaborationId>',
        method: 'GET',
        staleTime: 5*60*1000
    },
    FETCH_MAP_PLACES: {
        method: 'POST',
        url: 'https://places.googleapis.com/v1/places:autocomplete'
    },
    FETCH_PLACE: {
        method: 'GET',
        url: 'https://places.googleapis.com/v1/places/<placeId>'
    },
    STORE_ADDRESS: {
        method: 'POST',
        url: 'i/address'
    },
    FETCH_INFLUENCER_ADDRESSES: {
        method: 'GET',
        url: '/ops/influencer/<influencerId>/address',
        staleTime: 10*60*1000   
    },
    UNDO_COLLABORATION_STEP: {
        method: 'POST',
        url: '/ops/campaign/<campaignId>/collaboration/<collaborationId>/step/undo'
    },
    CREATE_FIREBASE_TOKEN: {
        url: '/ops/firebase-token',
        method: 'POST',
        staleTime: 50*60*1000
    },
    COLLAB_CHAT_ROOM: {
        url: '/ops/campaign/<campaignId>/collaboration/<collaborationId>/chat-room',
        method: 'POST',
        staleTime: 10*60*1000
    },
    FETCH_BASIC_SOCIAL_POST: {
        method: 'url',
        url: '/ops/social-post/<postId>',
        staleTime: 10*60*1000
    },
    FETCH_SOCIAL_POST: {
        url: '/ops/social-account/<socialAccountId>/post/<socialPostId>',
        method: 'GET',
        staleTime: 1*60*1000
    },
    FETCH_SOCIAL_POSTS: {
        url: '/ops/social-account/<socialAccountId>/post',
        method: 'GET',
        staleTime: 10*60*1000
    },
    FETCH_LATEST_SOCIAL_MEDIA: {
        url: '/ops/social-account/<socialAccountId>/fetch-media',
        method: 'POST'
    },
    RESET_COLLAB: {
        url: '/ops/campaign/<campaignId>/collaboration/<collaborationId>/reset',
        method: 'POST'
    },
    FORCE_COMPLETE_MILESTONE: {
        url: '/ops/campaign/<campaignId>/collaboration/<collaborationId>/milestone/force-complete',
        method: 'POST'
    },
    REFRESH_STEPS: {
        url: '/ops/campaign/<campaignId>/collaboration/<collaborationId>/milestone/<milestoneId>/refresh-steps',
        method: 'POST'
    },
    UPDATE_CTA_URL: {
        url: '/ops/campaign/<campaignId>/collaboration/<collaborationId>/milestone/<milestoneId>/cta',
        method: "POST"
    },
    FORCE_PROCESS_STEP: {
        url: '/ops/campaign/<campaignId>/collaboration/<collaborationId>/step/force',
        method: 'POST'
    },
    ATTACH_IG_PERMALINK: {
        url: '/ops/campaign/<campaignId>/collaboration/<collaborationId>/attach-ig-permalink',
        method: 'POST'
    },
    FETCH_URL_METADATA: {
        url: '/ops/url/md',
        method: 'POST'
    },
    CREATE_ADDRESS: {
        url: '/ops/address',
        method: 'POST'
    },
    DISCOVER_CREATORS: {
        url: '/ops/creator-discovery',
        method: 'POST',
    },
    FETCH_CREATOR_DISCOVERY_DETAILS: {
        url: '/ops/creator-discovery/<discoveryId>',
        method: 'GET'
    },
    FETCH_DISCOVERED_CREATORS: {
        url: '/ops/creator-discovery/<discoveryId>/creator',
        method: 'GET'
    },
    RECENT_DISCOVERIES: {
        url: '/ops/creator-discovery',
        method: 'GET'
    },
    INVITE_CREATORS_TO_CAMPAIGN: {
        url: '/ops/campaign/<campaignId>/invite/discovery',
        method: 'POST',
    },
    FETCH_RECOMMENDED_CREATORS: {
        url: '/ops/campaign/<campaignId>/creator-recommendation',
        method: 'GET',
        staleTime: 5 * 60 * 1000,
    },
    GENERATE_CREATOR_RECOMMENDATION: {
        url: '/ops/campaign/<campaignId>/creator-recommendation',
        method: 'POST',
    },
    FETCH_CAMPAIGN_INVITED_CREATORS: {
        url: '/ops/campaign/<campaignId>/invite',
        method: 'GET',
        staleTime: 5 * 60 * 1000,
    },
    ONBOARD_CREATOR: {
        url: '/ops/social-account/<socialAccountId>/dm',
        method: 'POST',
    },
    REPLY_CREATOR_DM: {
        url: '/ops/social-account/<socialAccountId>/dm/<sessionId>/reply',
        method: 'POST',
    },
    STORE_COLLAB_REMOVAL_REQUEST: {
        url: '/ops/campaign/<campaignId>/collaboration/<collaborationId>/delete-request',
        method: 'POST',
    },
    FETCH_COLLAB_DELETION_REQUESTS: {
        url: '/ops/collaboration/deletion-request',
        method: 'GET',
        staleTime: 0 * 60 * 1000, // no caching
    },
    DECLINE_COLLAB_DELETION_REQUEST: {
        url: '/ops/campaign/<campaignId>/collaboration/<collaborationId>/delete-request/<requestId>/reject',
        method: 'POST',
    },
    ACCEPT_COLLAB_DELETION_REQUEST: {
        url: '/ops/campaign/<campaignId>/collaboration/<collaborationId>',
        method: 'DELETE',
    },
    SHOW_COLLAB_DELETION_REQUEST: {
        url: '/ops/campaign/<campaignId>/collaboration/<collaborationId>/delete-request/<requestId>',
        method: 'GET',
        staleTime: 10 * 60 * 1000,
    },
    COUNTRY: {
        url: '/country',
        method: 'GET'
    },
    FETCH_INVITES: {
        url: '/ops/invite',
        method: 'GET',
        staleTime: 5 * 60 * 1000,
    }
}

export default apiConfig